import { MultiDropdownOption } from "./types";

export const initialMultiDropdownItem: MultiDropdownOption = {
  value: "",
  text: "Odaberi",
};

export const GetDropdownItem = (
  options: MultiDropdownOption[],
  value: any,
  placeholder?: string | null
): MultiDropdownOption => {
  let item = options.find((i) => i.value === value);

  if (!item) {
    item = {
      ...initialMultiDropdownItem,
      text: placeholder ?? initialMultiDropdownItem.text,
    };
  }
  return item;
};
